// this component was automatically generated by IconGlyph.template.js
import React from 'react';
import { TestId } from '@trello/test-ids';

import { Icon, IconColor, IconSize } from '../src/components/Icon';

export interface GlyphProps {
  /**
   * A string that is applied as an aria attribute on the icon. Usually it
   * matches up with the display name of the icon
   * @default If no label is provided, it will fallback to the name of the icon
   */
  label?: string;
  /**
   * The color that the Icon should be rendered as.
   * @default @icon-default-color (#42526E)
   */
  color?: IconColor;
  /**
   * The size to render the Icon size.
   * @default "medium"
   */
  size?: IconSize;
  /**
   * A string that gets placed as a data attribute (data-test-id) onto the
   * Icon wrapper so that our
   * smoketest can properly target and test the component
   * @default undefined
   */
  testId?: TestId;
  // Escape hatches
  /**
   * ⚠️ DO NOT USE THIS PROP UNLESS YOU REALLY REALLY HAVE TO.
   *
   * Places a class name on the Icon (more specifically, the svg itself). This
   * is placed in addition to the classes already placed on the Icon. This is
   * placed directly onto the SVG via the glyph templates that are
   * generated by IconGlyph.template.js
   *
   * Please refrain from using this unless absolutely necessary.
   * @default undefined
   */
  dangerous_className?: string;
}

const TableIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 14 10"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.667 9.667A1.333 1.333 0 01.333 8.333V1.667C.333.93.93.333 1.667.333h10.666c.737 0 1.334.597 1.334 1.334v6.666c0 .737-.597 1.334-1.333 1.334H1.667zm10.666-4V4.333H5.668v1.334h6.667zm0-2.667V1.667H5.668V3h6.667zm0 4v1.333H5.668V7h6.667zM1.668 4.333v1.334h2.667V4.333H1.667zm0 2.667v1.333h2.667V7H1.667zm0-4V1.667h2.667V3H1.667z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TableIcon: React.FunctionComponent<GlyphProps> = (props) => {
  const { testId, dangerous_className, size, color, label } = props;
  return (
    <Icon
      testId={testId}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      label={label || 'TableIcon'}
      glyph={TableIconGlyph}
    />
  );
};
